import request from '@/router/axios'

export function getPage(data) {
    return request({
        url: '/chain/ledgerDig/getWorkFlowPage',
        method: 'post',
        data
    })
}
